import React, { useEffect } from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import InsightsIcon from '../../../assets/images/InsightsIcon.svg';
import GenericTile from './GenericTile';

const InsightsTile = ({ buttonSize, fullHeight }) => {
    const insightsLink =
        'https://www.troweprice.com/personal-investing/planning-and-research/t-rowe-price-insights/explore-insights.html';
    const smallScreenSize = window.matchMedia('(max-width: 960px)');
    const [smallScreen, setSmallScreen] = React.useState(window.innerWidth <= 960 ? true : false);

    useEffect(() => {
        const handleResize = () => {
            setSmallScreen(smallScreenSize);
        };
        smallScreenSize.addEventListener('change', handleResize);
        return () => smallScreenSize.removeEventListener('change', handleResize);
    }, []);

    const viewInsights = (link) => {
        window.open(link, '_blank');
    };

    return (
        <GenericTile
            buttonVariant="tertiary"
            title="T. Rowe Price Insights®"
            description="Explore our latest investing thinking, information on retirement Planning, and timely perspectives on the markets."
            buttonText="View Insights"
            id="view-insights"
            fullHeight={fullHeight}
            icon={InsightsIcon}
            buttonSize={buttonSize}
            smallScreenSize={smallScreen}
            onClick={() => viewInsights(insightsLink)}
        />
    );
};

export default InsightsTile;
